import { useLocation } from '../../../../context/LocationContext';
import { DeliveryMethodDtoType } from '@ordr-as/ordr-service-types/epos';
import { useCheckout } from '../../../../context/CheckoutContext';
import classNames from 'clsx';
import { memo } from 'react';

const className = (selected: boolean) =>
  classNames({
    'neutral border-grey-medium ': !selected,
    'text-brand-primary font-semibold': selected,
    'text-center text-nowrap border flex items-center h-6 py-4 text-sm hover:opacity-75': true,
  });

const EatInOrTakeaway = () => {
  const { location } = useLocation();
  const { vatType, setVatType } = useCheckout();

  const takeaway = location.deliveryMethods.find((method) => method.type === DeliveryMethodDtoType.TAKEAWAY);
  const counter = location.deliveryMethods.find((method) => method.type === DeliveryMethodDtoType.COUNTER);
  const table = location.deliveryMethods.find((method) => method.type === DeliveryMethodDtoType.TABLE);

  if (!takeaway?.enabled && !table?.enabled && !counter?.enabled) {
    return null;
  }

  if (!takeaway?.enabled) {
    return null;
  }

  return (
    <div className="flex">
      <div className="inline-flex items-center">
        <input id="EAT_IN" type="radio" onChange={() => setVatType('EAT_IN')} checked={vatType === 'EAT_IN'} hidden />
        <label htmlFor="EAT_IN" className={`${className(vatType === 'EAT_IN')} pr-3 pl-4 rounded-l-full`}>
          Eat In
        </label>
      </div>
      <div className="inline-flex items-center">
        <input
          type="radio"
          id="TAKEAWAY"
          checked={vatType === 'TAKEAWAY'}
          onChange={() => setVatType('TAKEAWAY')}
          hidden
        />
        <label htmlFor="TAKEAWAY" className={`${className(vatType === 'TAKEAWAY')} pl-2 pr-4 rounded-r-full`}>
          Takeaway
        </label>
      </div>
    </div>
  );
};

export default memo(EatInOrTakeaway);
